import * as storeTypes from "./storeTypes";
import { ISessionState } from "../session/sessionState";
import { IInstantMessageListItem } from "ui/Scripts/source/models/instantMessage/instantMessageListItem";
// Action creators

// Fetch
export const fetchStart = (): storeTypes.IFetchStart => ({
    type: storeTypes.FETCH_START
});

export const fetchEnd = (): storeTypes.IFetchEnd => ({
    type: storeTypes.FETCH_END
});

// Alert
export const showSuccessMessage = (message: string): storeTypes.IAlertSuccess => ({
    type: storeTypes.ALERT_SUCCESS,
    message
});

export const showInfoMessage = (message: string): storeTypes.IAlertInfo => ({
    type: storeTypes.ALERT_INFO,
    message
});

export const showErrorMessage = (message: string): storeTypes.IAlertError => ({
    type: storeTypes.ALERT_ERROR,
    message
});

export const clearMessages = (): storeTypes.IAlertClear => ({
    type: storeTypes.ALERT_CLEAR
});

export const clearSuccessMessage = (): storeTypes.IAlertSuccessClear => ({
    type: storeTypes.ALERT_SUCCESS_CLEAR
});

export const clearInfoMessage = (): storeTypes.IAlertInfoClear => ({
    type: storeTypes.ALERT_INFO_CLEAR
});

// Confirmation
export const setConfirmation = (type: storeTypes.ConfirmationDialogType, title: string, text: string, onYes: storeTypes.IConfirmationCallback, onNo: storeTypes.IConfirmationCallback, onCancel: storeTypes.IConfirmationCallback = null, yesConfirmationText: string = null): storeTypes.IConfirmationSet => ({
    type: storeTypes.CONFIRMATION_SET,
    dialogType: type,
    title,
    text,
    show: true,
    yesConfirmationText,
    onYes,
    onNo,
    onCancel
});

export const clearConfirmation = (): storeTypes.IConfirmationClear => ({
    type: storeTypes.CONFIRMATION_CLEAR
});

// AutoLogout
export const autoLogoutSet = (): storeTypes.IAutoLogoutSet => ({
    type: storeTypes.AUTOLOGOUT_SET
});

export const autoLogoutClear = (): storeTypes.IAutoLogoutClear => ({
    type: storeTypes.AUTOLOGOUT_CLEAR
});

// Session
export const setSessionsState = (sessionState: ISessionState): storeTypes.ISetSessionState => ({
    type: storeTypes.SESSION_SET_STATE,
    sessionState
});

export const setNewInstantMessages = (newInstantMessages: IInstantMessageListItem[]): storeTypes.ISetNewInstantMessages => ({
    type: storeTypes.NEW_INSTANT_MESSAGES_SET,
    newInstantMessages
});
